(ns app.new-workspace.subs
  (:require [re-posh.core :as re-posh]))


(re-posh/reg-sub
 ::new-workspace-id
 (fn [_ _]
   {:type  :query
    :query '[:find ?id .
             :where [?id :app/type :type/new-workspace]]}))

(re-posh/reg-sub
 ::new-workspace
 :<- [::new-workspace-id]
 (fn [id _]
   {:type    :pull
    :pattern '[:db/id :new-workspace/value]
    :id      id}))